<script lang="ts">
import type { CalendarGridRowProps } from '..'
import { CalendarGridRow } from '..'

export interface DatePickerGridRowProps extends CalendarGridRowProps {}
</script>

<script setup lang="ts">
const props = defineProps<DatePickerGridRowProps>()
</script>

<template>
  <CalendarGridRow v-bind="props">
    <slot />
  </CalendarGridRow>
</template>
